import { isEmpty as _isEmpty } from 'lodash';
import GradedItem from '../api/gradedItem';

export const fetchGradedItems = (cohortId, bootcampId, studentId) => async () => {
  const items = await GradedItem.getGradedItems(cohortId, bootcampId, studentId);
  return _isEmpty(items) ? [] : items;
};
